export default __webpack_public_path__ + "static/media/grade.d6743272.png";